






























































import Vue from "vue";
import Component from "vue-class-component";
import rules from "../../utils/rules";

@Component
export default class ResetPassword extends Vue {
  valid = true;
  show = false;
  loadingChangePassword = false;
  snackbarChangePasswordError = false;
  password = "";
  passwordRules = [rules.notEmpty, rules.password];

  private changePassword(): void {
    this.loadingChangePassword = true;
    this.$store
      .dispatch("authentication/changePassword", {
        password: this.password,
        token: this.$route.query.token
      })
      .then((response: any) => {
        this.loadingChangePassword = false;
        if (response.updated) {
          this.$router.push("/admin/sign-in");
        } else {
          this.snackbarChangePasswordError = true;
        }
      });
  }
}
